import { createFileRoute } from "@tanstack/react-router";
import GeneratorGuide from "@/pages/GeneratorGuide";

export const Route = createFileRoute("/best-generators-uk")({
  component: GeneratorGuide,
});
